import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, Panel, Stars, fmtDT } from "@/components/admin/ui";

export default function StoreFeedback() {
  const { sid } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/stores/${sid}/feedback`).then((r) => setD(r.data)).catch(() => setD({ items: [], count: 0, average: null })); }, [sid]);
  if (!d) return <div className="p-10 text-neutral-500">Loading…</div>;
  const dist = [5, 4, 3, 2, 1].map((n) => [n, d.items.filter((i) => i.rating === n).length]);
  return (
    <div className="p-6 lg:p-10">
      <PageHeader eyebrow="Store · Guests" title="Customer Feedback" testId="feedback-title" subtitle={`${d.count} review${d.count !== 1 ? "s" : ""}`}/>
      <div className="grid md:grid-cols-[260px_1fr] gap-4">
        <Panel className="p-5">
          <div className="font-display font-bold text-5xl" data-testid="feedback-avg">{d.average ?? "—"}</div>
          <Stars value={Math.round(d.average || 0)}/>
          <div className="mt-4 space-y-1.5">
            {dist.map(([n, c]) => (
              <div key={n} className="flex items-center gap-2 text-xs"><span className="w-3">{n}</span>
                <div className="flex-1 h-2 bg-neutral-100 rounded-full overflow-hidden"><div className="h-full bg-amber-400" style={{ width: d.count ? `${(100 * c) / d.count}%` : 0 }}/></div><span className="w-5 text-right text-neutral-500">{c}</span></div>
            ))}
          </div>
        </Panel>
        <Panel className="divide-y divide-neutral-100">
          {d.items.length === 0 && <p className="p-10 text-center text-sm text-neutral-500" data-testid="feedback-empty">No feedback yet. Print the Feedback QR code to start collecting reviews.</p>}
          {d.items.map((f) => (
            <div key={f.id} className="p-4 text-sm" data-testid={`feedback-${f.id}`}>
              <div className="flex items-center justify-between gap-3"><Stars value={f.rating}/><span className="text-xs text-neutral-500">{fmtDT(f.created_at)}</span></div>
              {f.comment && <p className="mt-1.5 text-neutral-700">{f.comment}</p>}
              <div className="text-xs text-neutral-400 mt-1">{f.name || f.email || "Anonymous"}{f.order_id ? ` · order ${f.order_id.slice(0, 6)}` : ""}</div>
            </div>
          ))}
        </Panel>
      </div>
    </div>
  );
}
